"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transformers = void 0;

var _Abs = require("./Abs");

var _Add = require("./Add");

var _AtIndex = require("./AtIndex");

var _Clone = require("./Clone");

var _CloneDeep = require("./CloneDeep");

var _Concat = require("./Concat");

var _DateDifference = require("./DateDifference");

var _Divide = require("./Divide");

var _Filter = require("./Filter");

var _Find = require("./Find");

var _FindIndex = require("./FindIndex");

var _FindLast = require("./FindLast");

var _FindLastIndex = require("./FindLastIndex");

var _First = require("./First");

var _Flat = require("./Flat");

var _FlatMap = require("./FlatMap");

var _GetParent = require("./GetParent");

var _GetRow = require("./GetRow");

var _GetRowIndex = require("./GetRowIndex");

var _GetValue = require("./GetValue");

var _Identity = require("./Identity");

var _Join = require("./Join");

var _Last = require("./Last");

var _Length = require("./Length");

var _Map = require("./Map");

var _Modulo = require("./Modulo");

var _Multiply = require("./Multiply");

var _Property = require("./Property");

var _Reduce = require("./Reduce");

var _ReduceRight = require("./ReduceRight");

var _Reject = require("./Reject");

var _Reverse = require("./Reverse");

var _Slice = require("./Slice");

var _Split = require("./Split");

var _Subtract = require("./Subtract");

var _ToNumber = require("./ToNumber");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var transformers = [_Abs.AbsTransformer, _Add.AddTransformer, _AtIndex.AtIndexTransformer, _Clone.CloneTransformer, _CloneDeep.CloneDeepTransformer, _Concat.ConcatTransformer, _DateDifference.DateDifferenceTransformer, _Divide.DivideTransformer, _Filter.FilterTransformer, _Find.FindTransformer, _FindIndex.FindIndexTransformer, _FindLast.FindLastTransformer, _FindLastIndex.FindLastIndexTransformer, _First.FirstTransformer, _Flat.FlatTransformer, _FlatMap.FlatMapTransformer, _GetParent.GetParentTransformer, _GetRow.GetRowTransformer, _GetRowIndex.GetRowIndexTransformer, _GetValue.GetValueTransformer, _Identity.IdentityTransformer, _Join.JoinTransformer, _Last.LastTransformer, _Length.LengthTransformer, _Map.MapTransformer, _Modulo.ModuloTransformer, _Multiply.MultiplyTransformer, _Property.PropertyTransformer, _Reduce.ReduceTransformer, _ReduceRight.ReduceRightTransformer, _Reject.RejectTransformer, _Reverse.ReverseTransformer, _Slice.SliceTransformer, _Split.SplitTransformer, _Subtract.SubtractTransformer, _ToNumber.ToNumberTransformer].reduce(function (result, transformer) {
  return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, transformer.name, transformer));
}, {});

var Transformers = /*#__PURE__*/function () {
  function Transformers() {
    _classCallCheck(this, Transformers);
  }

  _createClass(Transformers, null, [{
    key: "addTransformer",
    value: function addTransformer(name, transformer) {
      Transformers.transformers[name] = transformer;
    }
  }, {
    key: "addTransformers",
    value: function addTransformers(transformers) {
      Transformers.transformers = _objectSpread(_objectSpread({}, Transformers.transformers), transformers);
    }
  }, {
    key: "getTransformer",
    value: function getTransformer(name) {
      return Transformers.transformers[name];
    }
  }, {
    key: "getTransformers",
    value: function getTransformers() {
      return Transformers.transformers;
    }
  }]);

  return Transformers;
}();

exports.Transformers = Transformers;

_defineProperty(Transformers, "transformers", transformers);